import { render, staticRenderFns } from "./BusinessClass.vue?vue&type=template&id=22ff7dea&"
import script from "./BusinessClass.vue?vue&type=script&lang=js&"
export * from "./BusinessClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports